/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo, useState, useEffect } from "react";
import objectPath from "object-path";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../_helpers";
import { AsideSearch } from "./AsideSearch";
import { AsideMenu } from "./aside-menu/AsideMenu";
import { LanguageSelectorDropdown } from "../extras/dropdowns/LanguageSelectorDropdown";
import { QuickUserToggler } from "../extras/QuickUserToggler";
import { Brand } from "../brand/Brand";
import { KTUtil } from "./../../../_assets/js/components/util";
import { NavLink, useLocation } from "react-router-dom";

import { shallowEqual, useSelector } from "react-redux";
import { SystemUserUiSettings } from "../../../../app/modules/SystemUser/pages/_redux/system-user-childs/SystemUserUiSettings";
export function Aside() {
  const uiService = useHtmlClassService();
  const user = useSelector((state) => state.auth.user, shallowEqual);

  var systemUserUiSettings = new SystemUserUiSettings();
  systemUserUiSettings.Set(user);

  const layoutProps = useMemo(() => {
    return {
      asideClassesFromConfig: uiService.getClasses("aside", true),
      asideSecondaryDisplay: objectPath.get(
        uiService.config,
        "aside.secondary.display"
      ),
      asideSelfMinimizeToggle: objectPath.get(
        uiService.config,
        "aside.self.minimize.toggle"
      ),
      extrasSearchDisplay: objectPath.get(
        uiService.config,
        "extras.search.display"
      ),
      extrasNotificationsDisplay: objectPath.get(
        uiService.config,
        "extras.notifications.display"
      ),
      extrasQuickActionsDisplay: objectPath.get(
        uiService.config,
        "extras.quick-actions.display"
      ),
      extrasQuickPanelDisplay: objectPath.get(
        uiService.config,
        "extras.quick-panel.display"
      ),
      extrasLanguagesDisplay: objectPath.get(
        uiService.config,
        "extras.languages.display"
      ),
      extrasUserDisplay: objectPath.get(
        uiService.config,
        "extras.user.display"
      ),
    };
  }, [uiService]);

  const tabs = {
    tabId1: "kt_aside_tab_1",
    tabId2: "kt_aside_tab_2",
  };
  const [activeTab, setActiveTab] = useState(tabs.tabId1);
  const handleTabChange = (id) => {
    setActiveTab(id);
    const asideWorkspace = KTUtil.find(
      document.getElementById("kt_aside"),
      ".aside-secondary .aside-workspace"
    );
    if (asideWorkspace) {
      KTUtil.scrollUpdate(asideWorkspace);
    }
  };

  let location = useLocation();
  useEffect(() => {}, [location]);
  return (
    <>
      {/* begin::Aside */}
      <div
        id="kt_aside"
        className={`aside aside-left d-flex ${layoutProps.asideClassesFromConfig}`}
      >
        {/* begin::Primary */}
        <div className="aside-primary d-flex flex-column align-items-center flex-row-auto">
          {/* <Brand /> */}
          <div />
          {/* begin::Nav Wrapper */}
          <div className="aside-nav d-flex flex-column align-items-center flex-column-fluid py-5 scroll scroll-pull">
            {/* begin::Nav */}
            <ul className="list-unstyled flex-column" role="tablist">
              {/* begin::Item */}
              {systemUserUiSettings.isCustomer && (
                <li
                  className="nav-item mb-3"
                  data-toggle="tooltip"
                  data-placement="rigth"
                  data-container="body"
                  data-boundary="window"
                  title="Unpaid invoices"
                >
                  <OverlayTrigger
                    placement="auto-end"
                    overlay={
                      <Tooltip id="upload-payment-file">Dashboard</Tooltip>
                    }
                  >
                    <div
                      className={`btn btn-icon btn-clean btn-lg w-40px h-40px ${
                        location.pathname.startsWith("/dashboard")
                          ? "selected-background"
                          : ""
                      }`}
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/dashboard"
                      >
                        <span className="symbol symbol-30 symbol-lg-40">
                          <span
                            className={`svg-icon svg-icon-lg ${
                              location.pathname.startsWith("/dashboard")
                                ? "svg-icon-primary"
                                : ""
                            }`}
                          >
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/Home/Home.svg"
                              )}
                            />
                          </span>
                        </span>
                        <span className="menu-text"></span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </div>
                  </OverlayTrigger>
                </li>
              )}

              {/* end::Item */}

              {/* begin::Item */}
              {systemUserUiSettings.isCustomer && (
                <li
                  className="nav-item mb-3"
                  data-toggle="tooltip"
                  data-placement="rigth"
                  data-container="body"
                  data-boundary="window"
                  title="Unpaid invoices"
                >
                  <OverlayTrigger
                    placement="auto-end"
                    overlay={
                      <Tooltip id="upload-payment-file">
                        Unpaid invoices
                      </Tooltip>
                    }
                  >
                    <div
                      className={`btn btn-icon btn-clean btn-lg w-40px h-40px ${
                        location.pathname.startsWith("/invoice")
                          ? "selected-background"
                          : ""
                      }`}
                    >
                      <NavLink className="menu-link menu-toggle" to="/invoice">
                        <span className="symbol symbol-30 symbol-lg-40">
                          <span
                            className={`svg-icon svg-icon-lg ${
                              location.pathname.startsWith("/invoice")
                                ? "svg-icon-primary"
                                : ""
                            }`}
                          >
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/Shopping/Box1.svg"
                              )}
                            />
                          </span>
                        </span>
                        <span className="menu-text"></span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </div>
                  </OverlayTrigger>
                </li>
              )}
              {(systemUserUiSettings.userType.systemUserType ==
                systemUserUiSettings.ADMIN || systemUserUiSettings.userType.systemUserType ==
                systemUserUiSettings.SUPER_ADMIN) && (
                <>
                  <li
                    className="nav-item mb-3"
                    data-toggle="tooltip"
                    data-placement="rigth"
                    data-container="body"
                    data-boundary="window"
                    title="Unpaid invoices"
                  >
                    <OverlayTrigger
                      placement="auto-end"
                      overlay={
                        <Tooltip id="upload-payment-file">
                          Admin dashboard
                        </Tooltip>
                      }
                    >
                      <div
                        className={`btn btn-icon btn-clean btn-lg w-40px h-40px ${
                          location.pathname.startsWith("/admin-dashboard")
                            ? "selected-background"
                            : ""
                        }`}
                      >
                        <NavLink to="/admin-dashboard">
                          <span className="symbol symbol-30 symbol-lg-40">
                            <span
                              className={`svg-icon svg-icon-lg ${
                                location.pathname.startsWith("/admin-dashboard")
                                  ? "svg-icon-primary"
                                  : ""
                              }`}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Home/Home.svg"
                                )}
                              />
                            </span>
                          </span>
                          <span className="menu-text"></span>
                          <i className="menu-arrow" />
                        </NavLink>
                      </div>
                    </OverlayTrigger>
                  </li>
                </>
              )}
              {systemUserUiSettings.isCustomer ? (
                <li
                  className="nav-item mb-3"
                  data-toggle="tooltip"
                  data-placement="auto-end"
                  data-container="body"
                  data-boundary="window"
                  title="Customers"
                >
                  <OverlayTrigger
                    placement="auto-end"
                    overlay={<Tooltip id="Customers">Customers</Tooltip>}
                  >
                    <div
                      className={`btn btn-icon btn-clean btn-lg w-40px h-40px ${
                        location.pathname.startsWith("/customers")
                          ? "selected-background"
                          : ""
                      }`}
                    >
                      <NavLink to="/customers">
                        <span className="symbol symbol-30 symbol-lg-40">
                          <span
                            className={`svg-icon svg-icon-lg ${
                              location.pathname.startsWith("/customers")
                                ? "svg-icon-primary"
                                : ""
                            }`}
                          >
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/Communication/Group.svg"
                              )}
                            />
                          </span>
                        </span>
                        <span className="menu-text"></span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </div>
                  </OverlayTrigger>
                </li>
              ) : (
                <li
                  className="nav-item mb-3"
                  data-toggle="tooltip"
                  data-placement="rigth"
                  data-container="body"
                  data-boundary="window"
                  title={systemUserUiSettings.childUsersType}
                >
                  <OverlayTrigger
                    placement="auto-end"
                    overlay={
                      <Tooltip id="Accounts">
                        {systemUserUiSettings.childUsersType}
                      </Tooltip>
                    }
                  >
                    <div
                      className={`btn btn-icon btn-clean btn-lg w-40px h-40px ${
                        location.pathname.startsWith("/user-childs")
                          ? "selected-background"
                          : ""
                      }`}
                    >
                      <NavLink to="/user-childs">
                        <span className="symbol symbol-30 symbol-lg-40">
                          <span
                            className={`svg-icon svg-icon-lg ${
                              location.pathname.startsWith("/user-childs")
                                ? "svg-icon-primary"
                                : ""
                            }`}
                          >
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/Communication/Add-user.svg"
                              )}
                            />
                          </span>
                        </span>
                        <span className="menu-text"></span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </div>
                  </OverlayTrigger>
                </li>
              )}
              {systemUserUiSettings.isCustomer && (
                <li
                  className="nav-item mb-3"
                  data-toggle="tooltip"
                  data-placement="rigth"
                  data-container="body"
                  data-boundary="window"
                  title="Account Settings"
                >
                  <OverlayTrigger
                    placement="auto-end"
                    overlay={
                      <Tooltip id="upload-payment-file">
                        Account Settings
                      </Tooltip>
                    }
                  >
                    <div
                      className={`btn btn-icon btn-clean btn-lg w-40px h-40px ${
                        location.pathname.startsWith("/account-settings")
                          ? "selected-background"
                          : ""
                      }`}
                    >
                      <NavLink
                        className="menu-link menu-toggle"
                        to="/account-settings"
                      >
                        <span className="symbol symbol-30 symbol-lg-40">
                          <span
                            className={`svg-icon svg-icon-lg ${
                              location.pathname.startsWith("/account-settings")
                                ? "svg-icon-primary"
                                : ""
                            }`}
                          >
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/General/Settings-1.svg"
                              )}
                            />
                          </span>
                        </span>
                        <span className="menu-text"></span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </div>
                  </OverlayTrigger>
                </li>
              )}
              {(systemUserUiSettings.userType.systemUserType ==
                systemUserUiSettings.ADMIN || systemUserUiSettings.userType.systemUserType ==
                systemUserUiSettings.SUPER_ADMIN) && (
                <li
                  className="nav-item mb-3"
                  data-toggle="tooltip"
                  data-placement="rigth"
                  data-container="body"
                  data-boundary="window"
                  title="Unpaid invoices"
                >
                  <OverlayTrigger
                    placement="auto-end"
                    overlay={
                      <Tooltip id="upload-payment-file">
                        unassigned Customers
                      </Tooltip>
                    }
                  >
                    <div
                      className={`btn btn-icon btn-clean btn-lg w-40px h-40px ${
                        location.pathname.startsWith("/unassigned-customers")
                          ? "selected-background"
                          : ""
                      }`}
                    >
                      <NavLink to="/unassigned-customers">
                        <span className="symbol symbol-30 symbol-lg-40">
                          <span
                            className={`svg-icon svg-icon-lg ${
                              location.pathname.startsWith(
                                "/unassigned-customers"
                              )
                                ? "svg-icon-primary"
                                : ""
                            }`}
                          >
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/General/Settings-1.svg"
                              )}
                            />
                          </span>
                        </span>
                        <span className="menu-text"></span>
                        <i className="menu-arrow" />
                      </NavLink>
                    </div>
                  </OverlayTrigger>
                </li>
              )}
              {/* end::Item */}
            </ul>
            {/* end::Nav */}
          </div>
          {/* end::Nav Wrapper */}

          {/* begin::Footer */}
          <div className="aside-footer d-flex flex-column align-items-center flex-column-auto py-4 py-lg-10">
            {/* begin::Aside Toggle */}
            {/* {layoutProps.asideSecondaryDisplay &&
              layoutProps.asideSelfMinimizeToggle && (
                <>
                  <OverlayTrigger
                    placement="right"
                    overlay={<Tooltip id="toggle-aside">Toggle Aside</Tooltip>}
                  >
                    <span
                      className="aside-toggle btn btn-icon btn-primary btn-hover-primary shadow-sm"
                      id="kt_aside_toggle"
                    >
                      <i className="ki ki-bold-arrow-back icon-sm" />
                    </span>
                  </OverlayTrigger>
                </>
              )} */}
            {/* end::Aside Toggle */}

            {/* begin::Search */}
            {layoutProps.extrasSearchDisplay && (
              <OverlayTrigger
                placement="auto-end"
                overlay={<Tooltip id="toggle-search">Quick Search</Tooltip>}
              >
                <a
                  href="#"
                  className="btn btn-icon btn-clean btn-lg mb-1"
                  id="kt_quick_search_toggle"
                >
                  <span className="svg-icon svg-icon-lg">
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")}
                    />
                  </span>
                </a>
              </OverlayTrigger>
            )}
            {/* end::Search */}

            {/* begin::Notifications */}
            {layoutProps.extrasNotificationsDisplay && (
              <OverlayTrigger
                placement="auto-end"
                overlay={
                  <Tooltip id="toggle-notifications">Notifications</Tooltip>
                }
              >
                <a
                  href="#"
                  className="btn btn-icon btn-clean btn-lg mb-1 position-relative"
                  id="kt_quick_notifications_toggle"
                  data-placement="auto-end"
                  data-container="body"
                  data-boundary="window"
                >
                  <span className="svg-icon svg-icon-lg">
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                    />
                  </span>
                </a>
              </OverlayTrigger>
            )}
            {/* end::Notifications */}

            {/* begin::Quick Actions */}
            {/* {layoutProps.extrasQuickActionsDisplay && (
              <OverlayTrigger
                placement="right"
                overlay={
                  <Tooltip id="toggle-quick-actions">Quick Actions</Tooltip>
                }
              >
                <a
                  href="#"
                  className="btn btn-icon btn-clean btn-lg mb-1"
                  id="kt_quick_actions_toggle"
                >
                  <span className="svg-icon svg-icon-lg">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Media/Equalizer.svg"
                      )}
                    />
                  </span>
                </a>
              </OverlayTrigger>
            )} */}
            {/* end::Quick Actions */}

            {/* begin::Quick Panel */}
            {/* {layoutProps.extrasQuickPanelDisplay && (
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="toggle-quick-panel">Quick Panel</Tooltip>}
              >
                <a
                  href="#"
                  className="btn btn-icon btn-clean btn-lg mb-1 position-relative"
                  id="kt_quick_panel_toggle"
                  data-placement="right"
                  data-container="body"
                  data-boundary="window"
                >
                  <span className="svg-icon svg-icon-lg">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Layout/Layout-4-blocks.svg"
                      )}
                    />
                  </span>
                  <span className="label label-sm label-light-danger label-rounded font-weight-bolder position-absolute top-0 right-0 mt-1 mr-1">
                    3
                  </span>
                </a>
              </OverlayTrigger>
            )} */}
            {/* end::Quick Panel */}

            {/* begin::Languages*/}
            {layoutProps.extrasLanguagesDisplay && <LanguageSelectorDropdown />}
            {/* end::Languages */}

            {/* begin::User*/}
            {layoutProps.extrasUserDisplay && <QuickUserToggler />}
            {/* end::User */}
          </div>
          {/* end::Footer */}
        </div>
        {/* end::Primary */}

        {/* {layoutProps.asideSecondaryDisplay && (
          <> */}
        {/* begin::Secondary */}
        {/* <div className="aside-secondary d-flex flex-row-fluid"> */}
        {/* begin::Workspace */}
        {/* <div className="aside-workspace scroll scroll-push my-2">
                <div className="tab-content">
                  <AsideSearch isActive={activeTab === tabs.tabId1} />
                  <AsideMenu isActive={activeTab === tabs.tabId2} />
                  <AsideSearch isActive={false} />
                  <AsideMenu isActive={false} />
                </div>
              </div> */}
        {/* end::Workspace */}
      </div>
      {/* end::Secondary */}
      {/* </>
        )}
      </div> */}
      {/* end::Aside */}
    </>
  );
}
